import React from 'react';
import './diagrams.css';
import './rulesdoc.css';

/* Case 03 — the encoded-taste rulebook, presented like a design-system spec
   page. This is the "design system" for a non-visual project: the taste,
   written down precisely enough that a model can apply it. */

const RULES = [
  { n: '01', rule: 'Tag the sender’s situation — not the lyric, not the genre.', do: '“not over you”, “wya”, “pretending I’m fine”', dont: '“breakup song”, “sad pop”, “Track 4”' },
  { n: '02', rule: 'Pass the 2am search-bar test.', do: 'what someone would actually type at 2am', dont: 'words no real person searches' },
  { n: '03', rule: 'Never copy a lyric line as a tag.', do: 'name the feeling underneath the line', dont: 'pasting the hook verbatim' },
  { n: '04', rule: '2–3 words. Never more than four.', do: '“missing my person”', dont: 'a full descriptive sentence' },
  { n: '05', rule: 'Never clinical or Wikipedia language.', do: 'how a friend would say it', dont: 'reads like a psychology textbook' },
  { n: '06', rule: 'Spread feels across the whole song.', do: 'different moments, verse to bridge', dont: 'three tags from the same 8 bars' },
];

export default function RulesDoc() {
  return (
    <figure className="ppd ppd--doc">
      <div className="ppd__head">
        <h3 className="ppd__title">The taste, encoded.</h3>
        <span className="ppd__tag">Tagging rulebook · excerpt</span>
      </div>

      <div className="rd">
        {RULES.map((r) => (
          <div key={r.n} className="rd__row">
            <span className="rd__n">{r.n}</span>
            <div className="rd__body">
              <p className="rd__rule">{r.rule}</p>
              <div className="rd__pair">
                <span className="rd__do"><i>do</i> {r.do}</span>
                <span className="rd__dont"><i>never</i> {r.dont}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <figcaption className="ppd__caption">
        The hard part was never the model — it was writing taste down this precisely.
        <b> This document is now one of our most valuable product assets</b>: the same rules a new
        teammate or an agent can both apply.
      </figcaption>
    </figure>
  );
}
